import { jsx as _jsx } from "react/jsx-runtime";
import { VENTURE_CATEGORIES } from "../model/constants";
/**
 * Badge component for displaying venture category with consistent styling
 *
 * Requirements:
 * - 4.1: Display venture category in detail views
 * - 9.2: Show category in public venture listings
 * - 12.2: Display category prominently
 * - 12.4: Show category in filtered views
 */
export const VentureCategoryBadge = ({ category, size = "md", className = "", }) => {
    // Category-based color schemes with subtle differentiation
    // Using light backgrounds with dark text for readability
    const getCategoryColor = () => {
        switch (category) {
            case "real_estate":
                return "bg-amber-50 text-amber-900 border-amber-200";
            case "hospitality":
                return "bg-pink-50 text-pink-900 border-pink-200";
            case "manufacturing":
                return "bg-slate-50 text-slate-900 border-slate-200";
            case "retail":
                return "bg-purple-50 text-purple-900 border-purple-200";
            case "service":
                return "bg-cyan-50 text-cyan-900 border-cyan-200";
            case "agriculture":
                return "bg-lime-50 text-lime-900 border-lime-200";
            default:
                return "bg-gray-50 text-gray-900 border-gray-200";
        }
    };
    // Mobile-friendly sizing with adequate touch targets
    const sizeClasses = {
        sm: "px-2 py-1 text-xs min-h-[32px]",
        md: "px-2.5 py-1.5 text-sm min-h-[36px]",
        lg: "px-3 py-2 text-base min-h-[44px]",
    };
    const label = VENTURE_CATEGORIES[category];
    const colorClasses = getCategoryColor();
    return (_jsx("span", { className: `inline-flex items-center justify-center rounded-full font-medium border ${sizeClasses[size]} ${colorClasses} ${className}`, role: "text", "aria-label": `Venture category: ${label}`, children: label }));
};
